import { render, staticRenderFns } from "./rolesManage.vue?vue&type=template&id=7d1f7208&scoped=true"
import script from "./rolesManage.vue?vue&type=script&lang=js"
export * from "./rolesManage.vue?vue&type=script&lang=js"
import style0 from "./rolesManage.vue?vue&type=style&index=0&id=7d1f7208&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1f7208",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d1f7208')) {
      api.createRecord('7d1f7208', component.options)
    } else {
      api.reload('7d1f7208', component.options)
    }
    module.hot.accept("./rolesManage.vue?vue&type=template&id=7d1f7208&scoped=true", function () {
      api.rerender('7d1f7208', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shopManage/rolesManage.vue"
export default component.exports